import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import * as styles from "./IconBarItem.styles";
export var IconBarItem = function IconBarItem(_ref) {
  var children = _ref.children,
    visibleAboveBreakpoint = _ref.visibleAboveBreakpoint,
    visibleBelowBreakpoint = _ref.visibleBelowBreakpoint;
  return /*#__PURE__*/React.createElement(_StyledLi, {
    $_css: [styles.item, styles.getVisibleAboveBreakpointStyles(visibleAboveBreakpoint), styles.getVisibleBelowBreakpointStyles(visibleBelowBreakpoint)]
  }, children);
};
export var IconBarItemLabel = function IconBarItemLabel(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: styles.label
  }, children);
};
var _StyledLi = _styled("li")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "IconBarItem___StyledSpan",
  componentId: "sc-grw9hz-0"
})(["", ""], function (p) {
  return p.$_css2;
});